import { put, select, takeLatest } from 'redux-saga/effects'
import { QuickActionsConstants } from '../store/quickActions.constants'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { compare } from '../../../utilities'
import { setMobileQuickActionButtonRows, setQuickActionButtonRows } from '../store/quickActions.actions'
import { IQuickActionButton } from '../store/quickActions.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* setQuickActionButtonGrid() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  try {
    const { filteredQuickActionButtons } = quickActionsObject
    const regex = /^(pertnegmed|pertnegproc)$/

    const updatedQuickActionButtons = filteredQuickActionButtons.filter(
      (data: IQuickActionButton) => !data.procName || !regex.test(data.procName?.toLowerCase().replace(/\s+/g, ''))
    )

    const rowOneButtons = updatedQuickActionButtons
      .filter((qa: any) => qa.buttonRow === 1)
      .sort((btn1: any, btn2: any) => compare(btn1.buttonCol, btn2.buttonCol))
    const rowTwoButtons = updatedQuickActionButtons
      .filter((qa: any) => qa.buttonRow === 2)
      .sort((btn1: any, btn2: any) => compare(btn1.buttonCol, btn2.buttonCol))
    const rowThreeButtons = updatedQuickActionButtons
      .filter((qa: any) => qa.buttonRow === 3)
      .sort((btn1: any, btn2: any) => compare(btn1.buttonCol, btn2.buttonCol))
    const rowFourButtons = updatedQuickActionButtons
      .filter((qa: any) => qa.buttonRow === 4)
      .sort((btn1: any, btn2: any) => compare(btn1.buttonCol, btn2.buttonCol))
    const rowFiveButtons = updatedQuickActionButtons
      .filter((qa: any) => qa.buttonRow === 5)
      .sort((btn1: any, btn2: any) => compare(btn1.buttonCol, btn2.buttonCol))

    const quickActionButtons = [
      { key: '1', buttons: rowOneButtons },
      { key: '2', buttons: rowTwoButtons },
      { key: '3', buttons: rowThreeButtons },
      { key: '4', buttons: rowFourButtons },
      { key: '5', buttons: rowFiveButtons },
    ]

    const concatenatedRows = [
      ...rowOneButtons,
      ...rowTwoButtons,
      ...rowThreeButtons,
      ...rowFourButtons,
      ...rowFiveButtons,
    ]
    let arrayIndexForMobile = 0
    const mobileRows = []

    for (let i = 0; i < 8; i++) {
      mobileRows.push(concatenatedRows.slice(arrayIndexForMobile, arrayIndexForMobile + 3))
      arrayIndexForMobile += 3
    }

    const mobileQuickActionButtons = [
      { key: '1', buttons: mobileRows[0] },
      { key: '2', buttons: mobileRows[1] },
      { key: '3', buttons: mobileRows[2] },
      { key: '4', buttons: mobileRows[3] },
      { key: '5', buttons: mobileRows[4] },
      { key: '6', buttons: mobileRows[5] },
      { key: '7', buttons: mobileRows[6] },
    ]
    yield put(setQuickActionButtonRows(quickActionButtons))
    yield put(setMobileQuickActionButtonRows(mobileQuickActionButtons))
  } catch (e) {
    yield put(throwPcrException(`setQuickActionButtonGrid() error: ${e}`))
  }
}

export function* setQuickActionButtonGridSaga() {
  yield takeLatest(
    [QuickActionsConstants.SET_FILTERED_QUICK_ACTION_BUTTONS],
    performWithMutexHOG,
    setQuickActionButtonGrid
  )
}
